// import Vue from 'vue'
import store from '@/store'
import router from '@/router'
import { CLAIMS_CLAIMDETAIL_LEAVEQUOTE } from '@/store/types'

export const SaveClaimMixin = {
  // Using beforeRouterEnter instead of created or any vue lifecycle because
  // Using vue lifecycle does not guarantee components are created before previous components are destroyed (the way how vue router deals with routing/lifecycle)
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // It listens to global event hub on event
      // It calls the page that listen to this to initiate doPartialSave
      // all quotation/proposal page should have this method (even if it is empty)
      vm.$root.$on('saveClaim', (toExit = false) => {
        vm.doPartialSave()
          .then((response) => {
            if (response === true && toExit) {
              vm.$root.$emit('leaveClaim')
            }
          })
      })

      vm.$root.$on('void', () => {
        vm.doPartialSave()
          .then((response) => {
            if (response === true) {
              // Do Void
              store.dispatch('voidClaim')
                .then((voidResponse) => {
                  // Vue.prototype.$snotify.success('Quotation status changed to Void')
                  store.commit(CLAIMS_CLAIMDETAIL_LEAVEQUOTE)
                  if (store.state.claims.claimDetail.commonForm.appID === 'MO') {
                    router.push({ name: 'motorClaimQuery', params: { id: store.state.claims.claimDetail.commonForm.clmRefNo } })
                  } else if (store.state.claims.claimDetail.commonForm.appID === 'TR') {
                    router.push({ name: 'travelClaimQuery', params: { id: store.state.claims.claimDetail.commonForm.clmRefNo } })
                  }
                })
            }
          })
      })
    })
  },
  // Not using vue router lifecycle (beforeRouteLeave) here because leaveClaim is using that lifeCycle to do its init work
  beforeDestroy() {
    this.$root.$off('saveClaim')
    this.$root.$off('void')
  }
}
